import store from '@/store'

export default function authHeader() {
    let data = {}

    const token = store.state.token

    if (token?.xsrf) {
        data['x-xsrf-token'] = token.xsrf
    }

    return data
}
